import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { changePassword } from "../services/api";
import "./AdminProfile.css";

function ChangePasswordForm() {
  const [form, setForm] = useState({ current_password:"", new_password:"", confirm:"" });
  const [saving,  setSaving]  = useState(false);
  const [error,   setError]   = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); setSuccess(null);
    if (!form.current_password || !form.new_password || !form.confirm)
      return setError("Todos los campos son requeridos.");
    if (form.new_password.length < 6)
      return setError("La contraseña debe tener al menos 6 caracteres.");
    if (form.new_password !== form.confirm)
      return setError("Las contraseñas nuevas no coinciden.");
    setSaving(true);
    try {
      await changePassword({ current_password: form.current_password, new_password: form.new_password });
      setSuccess("Contraseña actualizada correctamente.");
      setForm({ current_password:"", new_password:"", confirm:"" });
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="admin-profile-form">
      {[
        { name:"current_password", label:"Contraseña actual"           },
        { name:"new_password",     label:"Nueva contraseña"            },
        { name:"confirm",          label:"Confirmar nueva contraseña"  },
      ].map(({ name, label }) => (
        <div key={name} className="form-group">
          <label style={{ fontSize:"0.75rem", fontWeight:700 }}>{label}</label>
          <input type="password" name={name} value={form[name]} onChange={handleChange} />
        </div>
      ))}
      {error   && <p className="form-error">{error}</p>}
      {success && <p className="form-success">{success}</p>}
      <div className="form-actions">
        <button type="submit" disabled={saving} className="btn-gold">
          {saving ? "Guardando..." : "Actualizar Contraseña"}
        </button>
      </div>
    </form>
  );
}

export default function AdminProfile() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const isAdmin        = user?.role === "admin";
  const isCollaborator = user?.role === "collaborator";

  useEffect(() => {
    if (!loading && (!user || (!isAdmin && !isCollaborator))) navigate("/");
  }, [user, loading, navigate]);

  if (loading || !user) return null;

  const initials   = (user.first_name?.[0] || "") + (user.last_name?.[0] || "");
  const badgeLabel = isAdmin ? "ADMINISTRADOR" : "COLABORADOR";
  const badgeClass = isAdmin ? "admin"         : "collaborator";

  return (
    <div className="page">
      <div className="page-hero">
        <h1>Mi Perfil</h1>
      </div>

      <div className="container admin-profile-container">
        {/* Tarjeta de usuario */}
        <div className="card admin-info-card">
          <div className="admin-avatar">
            {initials || "U"}
          </div>
          <div className="admin-details">
            <h2>{user.first_name} {user.last_name}</h2>
            <p>{user.email}</p>
          </div>
          <div className="admin-badge-container">
            <span className={`navbar-badge ${badgeClass}`}>{badgeLabel}</span>
          </div>
        </div>

        {/* Permisos del colaborador (solo se muestra si es colaborador) */}
        {isCollaborator && (
          <div className="card" style={{ marginBottom:"1.5rem", background:"var(--teal-light)", border:"0.5px solid rgba(14,138,138,.2)" }}>
            <p style={{ fontFamily:"var(--font-display)", fontWeight:700, fontSize:"0.82rem", color:"var(--teal-dark)", marginBottom:".5rem" }}>
              Tus permisos como colaborador
            </p>
            <ul style={{ fontSize:"0.82rem", color:"var(--teal-dark)", lineHeight:2, paddingLeft:"1.2rem", margin:0 }}>
              <li>Crear y editar artículos</li>
              <li>Crear y editar recursos</li>
              <li>Ver estadísticas y progreso de alumnos</li>
            </ul>
          </div>
        )}

        {/* Seguridad */}
        <div className="card admin-security-card">
          <h3 className="section-title">Seguridad de la cuenta</h3>
          <ChangePasswordForm />
        </div>
      </div>
    </div>
  );
}